import { useEffect } from "react";
import { TopBar } from "../../shared/topBar/TopBar"

export const ClientReturnsList=()=>{
    useEffect(()=>{
        document.title="Client Returns List"
    },[]);
    return <>
    <TopBar label={"Client Return List"} />
        <div  className="mainContentData">
         
        </div>
    </>
}